/**
 * FN-FE-SUB-04 — Trial Banner + Lockout Banners
 */

interface Props {
  status: string;
  trialStartedAt: string | null;
  trialEndsAt: string | null;
  discount15Offered: boolean;
  discount15Applied: boolean;
  warning28Shown: boolean;
  dataPurgeAt: string | null;
}

const bannerBase: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  flexWrap: 'wrap', gap: '6px 12px',
  padding: '7px 16px', fontSize: '13px', lineHeight: 1.4,
};

const linkStyle: React.CSSProperties = {
  fontWeight: 700, textDecoration: 'underline', whiteSpace: 'nowrap', flexShrink: 0,
};

export default function TrialBanner({ status, trialStartedAt, trialEndsAt, discount15Offered, discount15Applied, warning28Shown, dataPurgeAt }: Props) {
  if (status === 'trial' && trialStartedAt) {
    const daysUsed = Math.floor((Date.now() - new Date(trialStartedAt).getTime()) / 86400000);
    const daysLeft = trialEndsAt ? Math.max(0, Math.ceil((new Date(trialEndsAt).getTime() - Date.now()) / 86400000)) : 30 - daysUsed;
    const urgent = daysLeft <= 2;

    return (
      <div style={{ ...bannerBase, background: urgent ? '#fef2f2' : '#fff7ed', color: urgent ? '#7f1d1d' : '#14233F' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', flex: 1, minWidth: 0 }}>
          <span>✨ Próba: {daysUsed} / 30 nap</span>
          {urgent && <strong style={{ color: '#dc2626' }}>⏰ {daysLeft} nap maradt!</strong>}
          {discount15Offered && !discount15Applied && (
            <span style={{ color: '#F47B20', fontWeight: 600 }}>· 🎁 10% kedvezmény az első fizetésnél</span>
          )}
        </div>
        <a href="/beallitasok/szamlazas" style={{ ...linkStyle, color: urgent ? '#dc2626' : '#F47B20' }}>Előfizetek most →</a>
      </div>
    );
  }

  if (status === 'past_due') {
    return (
      <div style={{ ...bannerBase, background: '#fef2f2', color: '#7f1d1d' }}>
        <span style={{ flex: 1, minWidth: 0 }}>⚠️ Az utolsó fizetésed sikertelen. 3 nap múlva korlátozzuk a hozzáférést.</span>
        <a href="/beallitasok/szamlazas" style={{ ...linkStyle, color: '#dc2626' }}>Frissítem a fizetési módot →</a>
      </div>
    );
  }

  if (status === 'grace' || status === 'read_only') {
    const daysUntilLock = status === 'grace' ? 7 : 20;
    return (
      <div style={{ ...bannerBase, background: '#fefce8', color: '#713f12' }}>
        <span style={{ flex: 1, minWidth: 0 }}>⚠️ Olvasás-csak mód. {daysUntilLock} nap múlva csak az előfizetés-menü lesz elérhető.</span>
        <a href="/beallitasok/szamlazas" style={{ ...linkStyle, color: '#92400e' }}>Frissítem →</a>
      </div>
    );
  }

  return null;
}
